import Cookies from "js-cookie";
export const useAccess = (accessId) => {
  const connectedUserAccess = Cookies.get("access");
  if (!connectedUserAccess) return false;
  try {
    const access = JSON.parse(connectedUserAccess);
    if (!Array.isArray(access)) return false;
    const id = Number(accessId);
    if (!Number.isFinite(id)) return false;
    return access.some((a) => Number(a) === id);
  } catch {
    return false;
  }
};
